<template>
  <sla-badge
    color="#FF9800"
    :show-tooltip="showTooltip"
    :tooltip-text="tooltipText"
    :tooltip-text2="tooltipText2"
    :text="text"
    :value="value"
  />
</template>

<script>
import SlaBadge from './SlaBadge.vue'

export default {
  components: {
    SlaBadge,
  },

  props: {
    showTooltip: Boolean,
    tooltipText: {
      type: String,
      default: null,
    },
    tooltipText2: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    value: {
      type: Number,
      default: null,
    },
  },
}
</script>
